export default __webpack_public_path__ + "static/media/FireFighting_04.17e342c0.png";